var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddtag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52886_146204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 7.33398C9.27731 7.33398 7.33331 9.27798 7.33331 11.6673C7.33331 14.0567 9.27731 16.0007 11.6666 16.0007C14.056 16.0007 16 14.0567 16 11.6673C16 9.27798 14.056 7.33398 11.6666 7.33398ZM13.3333 12.334H12.3333V13.334C12.3333 13.702 12.0346 14.0007 11.6666 14.0007C11.2986 14.0007 11 13.702 11 13.334V12.334H9.99998C9.63198 12.334 9.33331 12.0353 9.33331 11.6673C9.33331 11.2993 9.63198 11.0007 9.99998 11.0007H11V10.0007C11 9.63265 11.2986 9.33398 11.6666 9.33398C12.0346 9.33398 12.3333 9.63265 12.3333 10.0007V11.0007H13.3333C13.7013 11.0007 14 11.2993 14 11.6673C14 12.0353 13.7013 12.334 13.3333 12.334Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0H9.33333C8.60667 0 7.9 0.306667 7.4 0.833333L0.546667 7.96C0.193333 8.33333 0 8.82 0 9.33333C0 9.86667 0.206667 10.3733 0.586667 10.7467L5.25333 15.4133C5.62667 15.7933 6.13333 16 6.66667 16C7.03333 16 7.39333 15.9 7.7 15.7133C7.37333 15.3867 7.08 15.0267 6.84 14.6333C6.61333 14.7 6.36 14.64 6.19333 14.4733L1.52667 9.80667C1.4 9.68 1.33333 9.51333 1.33333 9.33333C1.33333 9.16 1.4 9 1.51333 8.88L8.36667 1.75333C8.62 1.48 8.96 1.33333 9.33333 1.33333H14C14.3667 1.33333 14.6667 1.63333 14.6667 2V6.66667C14.6667 6.72667 14.66 6.79333 14.6533 6.85333C15.06 7.10667 15.4333 7.40667 15.76 7.75333C15.92 7.41333 16 7.04 16 6.66667V2C16 0.9 15.1 0 14 0Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 4.66667C11.9313 4.66667 11.3333 4.06867 11.3333 3.33333C11.3333 2.598 11.9313 2 12.6666 2C13.402 2 14 2.598 14 3.33333C14 4.06867 13.402 4.66667 12.6666 4.66667Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52886_146204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtag);
export default __webpack_public_path__ + "static/media/Addtag.6c937b4825a7ec14f103fb6b8eb9ac5e.svg";
export { ForwardRef as ReactComponent };